module.exports = __webpack_public_path__ + "img/pinterest-logo.1da18e1.png";